import { z } from 'zod';

/**
 * Pagar.me v5 webhook payload (subset). The exact event types we care about:
 * - order.paid
 * - order.payment_failed
 * - charge.paid
 * - charge.refunded
 * - charge.dispute_opened
 * - charge.dispute_closed
 * - transfer.paid
 * - transfer.failed
 *
 * Reference: https://docs.pagar.me/v5/reference/webhooks
 */
export const pagarmeWebhookEventSchema = z.object({
  id: z.string(),
  type: z.string(),
  created_at: z.string(),
  account: z.object({ id: z.string(), name: z.string().optional() }),
  data: z.unknown(),
});

export const createPaymentSchema = z.object({
  taskId: z.string().uuid(),
  method: z.enum(['pix', 'credit_card', 'boleto']),
  installments: z.number().int().min(1).max(12).optional(),
  /** Card token from frontend (generated via pk_test_*). Required for credit_card. */
  cardToken: z.string().optional(),
  /** Customer document (CPF/CNPJ, digits only) for first-time buyers without a saved customerId. */
  customerDocument: z.string().regex(/^\d{11}$|^\d{14}$/).optional(),
});

export type PagarmeWebhookEvent = z.infer<typeof pagarmeWebhookEventSchema>;
export type CreatePaymentInput = z.infer<typeof createPaymentSchema>;
